export default __webpack_public_path__ + "static/media/iconCloseModal.3b9795b4.svg";